import { create } from 'zustand'
import SampleGeoJson from '../data/sample.json'

interface MapState {
  baseMapLayerVisibility: {
    Aerial: boolean
    Dark: boolean
    Light: boolean
    Topo: boolean
    Streets: boolean
  }
  setBaseLayerMapVisibility: (
    visibility: MapState['baseMapLayerVisibility']
  ) => void

  dataLayerVisibility: {
    rated_wd_mat_vw: boolean
    rated_gsa_mat_vw: boolean
    sgma_county: boolean
    hydra_gsa: boolean
    hydra_wd_vw: boolean
    state_wide_parcels_2024: boolean
    sgma_sagbi: boolean
    sgma_sagbi_unmod: boolean
    provisional_crops_2023: boolean
    sgma_ewrims: boolean
    aac_ca_region?: boolean
    fca_territories_2024?: boolean
    ca_grape_pricing_districts?: boolean
    yfc_territory?: boolean
    all_ranches: boolean
    queried_parcels: boolean
    filtered_parcels: boolean
  }
  setDataLayerVisibility: (visibility: MapState['dataLayerVisibility']) => void
  resetStore: () => void

  // New map view state
  mapLayerView: {
    zoom: number
    latitude: number
    longitude: number
    bearing: number // Rotation angle
    pitch: number // Tilt angle
    // Update more....
  }
  setMapLayerView: (view: MapState['mapLayerView']) => void
}

const initialDataLayerVisibility = {
  rated_wd_mat_vw: false,
  rated_gsa_mat_vw: false,
  sgma_county: false,
  hydra_gsa: false,
  hydra_wd_vw: false,
  state_wide_parcels_2024: false,
  sgma_sagbi: false,
  sgma_sagbi_unmod: false,
  provisional_crops_2023: false,
  sgma_ewrims: false,
  aac_ca_region: false,
  fca_territories_2024: false,
  ca_grape_pricing_districts: false,
  yfc_territory: false,
  all_ranches: false,
  queried_parcels: false,
  filtered_parcels: false,
}

const useMapStore = create<MapState>((set) => ({
  baseMapLayerVisibility: {
    Aerial: true,
    Dark: false,
    Light: false,
    Topo: false,
    Streets: false,
  },
  setBaseLayerMapVisibility: (visibility) =>
    set({ baseMapLayerVisibility: visibility }),

  // Data layer store
  dataLayerVisibility: initialDataLayerVisibility,
  setDataLayerVisibility: (visibility) =>
    set({ dataLayerVisibility: visibility }),
  resetDataLayerVisibility: () =>
    set({ dataLayerVisibility: initialDataLayerVisibility }),
  resetStore: () => {
    set({
      baseMapLayerVisibility: {
        Aerial: true,
        Dark: false,
        Light: false,
        Topo: false,
        Streets: false,
      },
      dataLayerVisibility: initialDataLayerVisibility,
      mapLayerView: {
        zoom: 14,
        latitude: SampleGeoJson.feature.properties.latitude,
        longitude: SampleGeoJson.feature.properties.longitude,
        bearing: 0,
        pitch: 0,
      },
    })
  },
  mapLayerView: {
    zoom: 14,
    latitude: SampleGeoJson.feature.properties.latitude,
    longitude: SampleGeoJson.feature.properties.longitude,
    bearing: 0,
    pitch: 0,
  },
  setMapLayerView: (view) => set({ mapLayerView: view }),
}))

export default useMapStore
